module.exports = __webpack_public_path__ + "static/media/Forbes-logo.c6a3b406.png";